import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { RegistroAfiliado } from 'src/app/models/generic/RegistroAfiliado';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { Constantes } from 'src/app/models/modules/Constantes';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ParametrosDatosNotificacion } from 'src/app/models/generic/ParametrosDatosNotificacion';

@Component({
  selector: 'confirm-afiliacion',
  templateUrl: './confirm-afiliacion.component.html',
  styleUrls: ['./confirm-afiliacion.component.scss']
})
export class ConfirmAfiliacionComponent implements OnInit{
  
  usuarioCreado: RegistroAfiliado;
  mostrarCargando: boolean = false;
  descripcionProducto: string = '';
  urlAliado: string = '';
  lineaNacionalAliado: string = '';
  nroFijoAliado: string = '';
  tieneSMS: boolean = false;
  tieneEmail: boolean = false;
  mensajesEnviados: boolean = false;
  listaParametrosNotificacion: ParametrosDatosNotificacion[] = [];

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      this.usuarioCreado = JSON.parse(this.menuService.ParametrosAdicionales);
      this.descripcionProducto = '';
      for (let index = 0; index < this.productosService.ListaProductos.length; index++) {
        if (this.productosService.ListaProductos[index].id === this.usuarioCreado.idProducto) {
          this.descripcionProducto = this.productosService.ListaProductos[index].descripcion;
        }
      }

      let parametros = this.configuracionService.ListasSistema.filter(x => x.lista === Constantes.LISTAS_PARAMETROS());
      for (let index = 0; index < parametros.length; index++) {
        if (parametros[index].codigo === 'LANDING_PAGE_ALIADO') {
          this.urlAliado = parametros[index].descripcion;
        } else if (parametros[index].codigo === 'LINEANACIONAL_ALIADO') {
          this.lineaNacionalAliado = parametros[index].descripcion;
        } else if (parametros[index].codigo === 'TELEFONO_ALIADO') {
          this.nroFijoAliado = parametros[index].descripcion;
        }
      }

      this.consultarDatosNotificacion();

      if (this.usuarioCreado.notificarCambios) {
        this.enviarNotificacion();
      }
    }
  }

  enviarNotificacion() {
    this.mostrarCargando = true;
    this.usuarioCreado.tipoNotificacion = '';
    this.productosService.Afiliado_Notificar(this.usuarioCreado)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              // console.log(resp);
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje)
              } else {
                this.mensajesEnviados = true;
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }

  continuarNavegacion() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }

  consultarDatosNotificacion() {
    let parametrosConsulta: FormGroup= this.fb.group({
      idAplicacion: [0],
      idAliado: [0],
      idProducto: [0]
    });

    parametrosConsulta.get('idAplicacion').setValue(this.usuarioCreado.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.usuarioCreado.idAliado);
    parametrosConsulta.get('idProducto').setValue(this.usuarioCreado.idProducto);
    
    this.productosService.ConsultarDatosNotificacionRegistro(parametrosConsulta.value)
            .subscribe((resp: ParametrosDatosNotificacion[]) =>{
              this.listaParametrosNotificacion = resp;
              let itemParametroFiltro: string = '';
              
              itemParametroFiltro = this.ObtenerValorParametro('URL_NOTIFICACION');
              if (this.utilitariosService.VerificarContieneDatosTexto(itemParametroFiltro)) {
                this.urlAliado = itemParametroFiltro;
              }

              itemParametroFiltro = this.ObtenerValorParametro('LINEA_NACIONAL');
              if (this.utilitariosService.VerificarContieneDatosTexto(itemParametroFiltro)) {
                this.lineaNacionalAliado = itemParametroFiltro;
              }

              itemParametroFiltro = this.ObtenerValorParametro('NRO_FIJO');
              if (this.utilitariosService.VerificarContieneDatosTexto(itemParametroFiltro)) {
                this.nroFijoAliado = itemParametroFiltro;
              }

              itemParametroFiltro = this.ObtenerValorParametro('ENVIAR_SMS');
              if (itemParametroFiltro === 'SI') {
                this.tieneSMS = true;
              }

              itemParametroFiltro = this.ObtenerValorParametro('ENVIAR_EMAIL');
              if (itemParametroFiltro === 'SI') {
                this.tieneEmail = true;
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ObtenerValorParametro(nombreParametro: string): string {
    let retorno: string = '';
    let itemFiltro = this.listaParametrosNotificacion.filter(x => x.parametro === nombreParametro);
    if (itemFiltro.length > 0) {
      if (this.utilitariosService.VerificarContieneDatosTexto(itemFiltro[0].valor)) {
        retorno = itemFiltro[0].valor;
      }
    }
    return retorno;
  }
  MensajeConfirmacionTipoNotificacion(): string {
    if (this.tieneEmail && this.tieneSMS) {
      return 'Fue enviado un Correo Electrónico y un SMS al afiliado de manera automática.';
    } else if (this.tieneEmail) {
      return 'Fue enviado un Correo Electrónico al afiliado de manera automática.';
    } else if (this.tieneSMS) {
      return 'Fue enviado un SMS al afiliado de manera automática.';
    } else {
      return '';
    }
  }

}
